var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 122,
    height: 155,
    viewBox: "0 0 122 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellisse_4",
    x: 0,
    y: 33,
    width: 122,
    height: 122,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2684",
    "data-name": "Raggruppa 2684",
    transform: "translate(-1419 -1255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_tag_on_100",
    transform: "translate(1434 1302.848)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -47.85)",
    filter: "url(#Ellisse_4)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_4-2",
    "data-name": "Ellisse 4",
    cx: 46,
    cy: 46,
    r: 46,
    transform: "translate(15 48)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_583",
    "data-name": "Rettangolo 583",
    transform: "translate(30 19.152)",
    fill: "none",
    stroke: "#38b29f",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 50,
    rx: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 29,
    height: 47,
    rx: 14.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_584",
    "data-name": "Rettangolo 584",
    transform: "translate(30 19.152)",
    fill: "#38b29f",
    stroke: "#38b29f",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 50,
    rx: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 29,
    height: 47,
    rx: 14.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "_100_",
    "data-name": "100%",
    transform: "translate(1452 1280)",
    fill: "#413333",
    fontSize: 24,
    fontFamily: "SourceSansPro-Regular, Source Sans Pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "100%")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveBattery);
export default __webpack_public_path__ + "static/media/move_battery.3abf4389074c7113e79c0e2b273f2ea3.svg";
export { ForwardRef as ReactComponent };